import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import SiteHold from './SiteHold';
import './styles/theme.css';

// Before launch the production build shows only the hold page (see .env.production).
const onHold = import.meta.env.VITE_SITE_HOLD === 'true';

const root = document.getElementById('root');

if (!root) {
  throw new Error('Vana root element not found');
}

createRoot(root).render(
  <StrictMode>
    {onHold ? <SiteHold /> : <App />}
  </StrictMode>,
);
